<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <calendar
                            @dayClick="dayClicked"
                            @eventClick="eventClicked"
                            :selected-job="job"
                            ref="calendar"
                        />
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="card">
                    <div
                        class="card-body"
                        id="job-details"
                    >
                        <h3 class="card-title">
                            Job Details
                        </h3>
                        <form
                            action=""
                            @submit.prevent="saveJob()"
                        >
                            <div class="row">
                                <div class="col-sm-12 col-md-8">
                                    <div class="form-group">
                                        <label for="name">Job Name:</label>
                                        <input
                                            name="name"
                                            v-model="job.name"
                                            id="name"
                                            class="form-control"
                                            required
                                        >
                                        <small
                                            class="form-error"
                                            v-if="errors.name"
                                        >{{ errors.name[0] }}</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2">
                                    <div class="form-group">
                                        <label for="colour">Job Colour:</label>
                                        <input
                                            name="colour"
                                            type="color"
                                            v-model="job.color"
                                            id="colour"
                                            class="form-control"
                                            required
                                        >
                                        <small
                                            class="form-error"
                                            v-if="errors.colour"
                                        >{{ errors.colour[0] }}</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2">
                                    <div class="form-group">
                                        <label for="type">Job Type:</label>
                                        <span style="display: block; width: 100%;">
                                            <input
                                                name="type"
                                                type="checkbox"
                                                v-model="job.is_call_out"
                                                id="type"
                                                class="form-control"
                                                style="display: inline-block; width: auto;"
                                            >
                                            Is call out?
                                        </span>
                                        <small
                                            class="form-error"
                                            v-if="errors.is_call_out"
                                        >{{ errors.is_call_out[0] }}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label for="customer">Customer:</label>
                                        <customer-search
                                            ref="customerSearch"
                                            :customer="job.customer"
                                            @change="customerChanged"
                                        />
                                        <small
                                            class="form-error"
                                            v-if="errors.customer_id"
                                        >{{ errors.customer_id[0] }}</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div
                                        class="form-group"
                                        v-if="job.customer.sites"
                                    >
                                        <label for="site">Site:</label>
                                        <select
                                            name="site"
                                            v-model="job.site_id"
                                            id="site"
                                            class="form-control"
                                            placeholder="Site"
                                            required
                                            v-if="job.customer.sites.length"
                                        >
                                            <option :value="null">
                                                Select site
                                            </option>
                                            <option
                                                v-for="site in job.customer.sites"
                                                :key="site.id"
                                                :value="site.id"
                                            >
                                                #{{ site.site_no }} {{ site.name }}
                                            </option>
                                        </select>
                                        <span
                                            class="form-error"
                                            v-if="!job.customer.sites.length"
                                        >This customer has no sites</span>
                                        <small
                                            class="form-error"
                                            v-if="errors.site_id"
                                        >{{ errors.site_id[0] }}</small>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label for="first_name">First name:</label>
                                        <input
                                            name="first_name"
                                            v-model="job.first_name"
                                            id="first_name"
                                            class="form-control"
                                            :required="isJobNew"
                                        >
                                        <small
                                            class="form-error"
                                            v-if="errors.first_name"
                                        >{{ errors.first_name[0] }}</small>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label for="last_name">Last name:</label>
                                        <input
                                            name="last_name"
                                            v-model="job.last_name"
                                            id="last_name"
                                            class="form-control"
                                            :required="isJobNew"
                                        >
                                        <small
                                            class="form-error"
                                            v-if="errors.last_name"
                                        >{{ errors.last_name[0] }}</small>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="important_info">Important Info:</label>
                                <textarea
                                    name="important_info"
                                    v-model="job.important_info"
                                    id="important_info"
                                    class="form-control"
                                    rows="4"
                                />
                                <small
                                    class="form-error"
                                    v-if="errors.important_info"
                                >{{ errors.important_info[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="description">Job Description:</label>
                                <textarea
                                    name="description"
                                    v-model="job.description"
                                    id="description"
                                    class="form-control"
                                    rows="4"
                                    placeholder="Date/times stated? Who have you spoke to? Cost agreed? Quote number? Any further information..."
                                    required
                                />
                                <small
                                    class="form-error"
                                    v-if="errors.description"
                                >{{ errors.description[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label>Times:</label>
                                <table class="table table-light-head">
                                    <thead>
                                        <th>Start:</th>
                                        <th />
                                        <th>End:</th>
                                        <th>Engineer:</th>
                                        <th v-if="job.time_slots && job.time_slots.length > 1" />
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(slot, index) in job.time_slots"
                                            :key="index"
                                        >
                                            <td>
                                                <date-picker
                                                    v-if="slot.start"
                                                    v-model="slot.start"
                                                    @input="validateTimeslot(index, slot)"
                                                    :options="{format: 'L'}"
                                                    required
                                                />
                                                <small
                                                    class="form-error"
                                                    v-if="errors['time_slots.'+index+'.start']"
                                                >{{ errors['time_slots.'+index+'.start'][0] }}
                                                </small>
                                            </td>
                                            <td>-</td>
                                            <td>
                                                <date-picker
                                                    v-if="slot.end"
                                                    v-model="slot.end"
                                                    @input="validateTimeslot(index, slot)"
                                                    :options="{format: 'L'}"
                                                    required
                                                />
                                                <small
                                                    class="form-error"
                                                    v-if="errors['time_slots.'+index+'.end']"
                                                >{{ errors['time_slots.'+index+'.end'][0] }}
                                                </small>
                                            </td>
                                            <td>
                                                <div class="form-group">
                                                    <select
                                                        name="user"
                                                        v-model="slot.user_id"
                                                        id="user"
                                                        class="form-control"
                                                        placeholder="Engineer"
                                                        @change="timeSlotUserChanged(index, slot)"
                                                        required
                                                    >
                                                        <option
                                                            v-for="user in engineers"
                                                            :key="user.id"
                                                            :value="user.id"
                                                            :disabled="!user.engineer_access"
                                                        >
                                                            {{ user.name }}
                                                        </option>
                                                    </select>
                                                    <small
                                                        class="form-error"
                                                        v-if="errors['time_slots.'+index+'.user_id']"
                                                    >
                                                        {{ errors['time_slots.'+index+'.user_id'][0] }}
                                                    </small>
                                                </div>
                                            </td>
                                            <td v-if="job.time_slots.length > 1">
                                                <button
                                                    @click.prevent="removeATime(index)"
                                                    class="btn btn-sm btn-outline-danger"
                                                >
                                                    <i class="fa fa-times" />
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="5">
                                                <button
                                                    class="btn btn-sm btn-outline-primary"
                                                    @click.prevent="addATime()"
                                                >
                                                    <i class="fa fa-plus" /> Add a time
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div class="form-group">
                                <label>Forms:</label>
                                <table
                                    class="table table-light-head"
                                >
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Doc No.</th>
                                            <th>Type</th>
                                            <th>Last Updated</th>
                                            <th><!-- options --></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(form, i) in job.forms"
                                            :key="i"
                                        >
                                            <td>{{ form.name }}</td>
                                            <td>{{ form.doc_no || '-' }}</td>
                                            <td>{{ form.nice_type }}</td>
                                            <td>{{ form.updated_at | datetime }}</td>
                                            <td>
                                                <router-link
                                                    :to="{name:'office.forms.new', query: {type: form.type, job_id: job.id}}"
                                                    class="btn btn-sm btn-info"
                                                    v-if="!form.id"
                                                >
                                                    <i class="fa fa-pencil-alt" />
                                                </router-link>
                                                <router-link
                                                    :to="{name: 'office.forms.edit', params: {id: form.id}}"
                                                    class="btn btn-sm btn-info"
                                                    v-if="form.id"
                                                >
                                                    <i class="fa fa-pencil-alt" />
                                                </router-link>
                                                <router-link
                                                    :to="{name:'office.forms.preview', params: {id: form.id}}"
                                                    class="btn btn-sm btn-info"
                                                    v-if="form.id"
                                                >
                                                    <i
                                                        class="fa fa-print"
                                                    />
                                                </router-link>
                                                <button
                                                    class="btn btn-sm btn-outline-danger"
                                                    @click.prevent="deleteForm(i)"
                                                    type="button"
                                                >
                                                    <i class="fa fa-times" />
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <select
                                                    name="form_type"
                                                    id="form_type"
                                                    v-model="newFormType"
                                                    class="form-control"
                                                >
                                                    <option
                                                        v-for="type in formTypes"
                                                        :key="type.value"
                                                        :value="type.value"
                                                    >
                                                        {{ type.name }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td colspan="5">
                                                <button
                                                    class="btn btn-sm btn-outline-primary"
                                                    @click.prevent="addAForm()"
                                                    type="button"
                                                >
                                                    <i class="fa fa-plus" /> Add a form
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                                <p
                                    class="error"
                                    v-if="!job.id"
                                >
                                    Save the job to add forms
                                </p>
                            </div>


                            <div class="form-group col-sm-12 col-md-6">
                                <label for="site">Job Status:</label>
                                <select
                                    name="status"
                                    v-model="job.status"
                                    id="status"
                                    class="form-control"
                                    placeholder="Status"
                                    required
                                >
                                    <option
                                        v-for="status in statuses"
                                        :key="status.value"
                                        :value="status.value"
                                    >
                                        {{ status.name }}
                                    </option>
                                </select>
                                <small
                                    class="form-error"
                                    v-if="errors.status"
                                >{{ errors.status[0] }}</small>
                            </div>

                            <div class="row">
                                <div class="form-group col-12 col-md-3">
                                    <label for="invoiced_at">Invoiced On:</label>
                                    <date-picker
                                        disabled="!job.id"
                                        v-model="job.invoiced_at"
                                        id="invoiced_at"
                                        :options="{format: 'L'}"
                                        required
                                    />
                                    <small
                                        class="form-error"
                                        v-if="errors['invoiced_at']"
                                    >
                                        {{ errors['invoiced_at'][0] }}
                                    </small>
                                </div>
                                <div class="form-group col-12 col-md-3">
                                    <label for="invoiced_by_id">Invoiced By:</label>
                                    <select
                                        disabled="!job.id"
                                        name="invoiced_by_id"
                                        v-model="job.invoiced_by_id"
                                        id="invoiced_by_id"
                                        class="form-control"
                                        placeholder="Staff"
                                    >
                                        <option
                                            :value="null"
                                            disabled
                                        >
                                            Select user
                                        </option>
                                        <option
                                            v-for="user in officeStaff"
                                            :key="user.id"
                                            :value="user.id"
                                        >
                                            {{ user.name }}
                                        </option>
                                    </select>
                                    <small
                                        class="form-error"
                                        v-if="errors['invoiced_by_id']"
                                    >
                                        {{ errors['invoiced_by_id'][0] }}
                                    </small>
                                </div>
                                <div class="form-group col-12 col-md-3">
                                    <label for="po_number">Purchase Order No.</label>
                                    <input
                                        v-model="job.po_number"
                                        id="po_number"
                                        type="text"
                                        class="form-control"
                                    >
                                    <small
                                        class="form-error"
                                        v-if="errors['po_number']"
                                    >
                                        {{ errors['po_number'][0] }}
                                    </small>
                                </div>
                            </div>

                            <div class="form-group">
                                <p v-if="job.created_by_user && job.created_at">
                                    Created by {{ job.created_by_user.name }} at {{ job.created_at.format(config.format) }}
                                </p>
                                <p v-if="job.updated_by_user && job.updated_at">
                                    Last updated by {{ job.updated_by_user.name }} at {{ job.updated_at.format(config.format) }}
                                </p>
                            </div>

                            <div
                                class="form-group"
                                v-if="job.customer_id "
                            > 
                                <label>Notes:</label>
                                <comments v-if="showNotes" />
                                <a
                                    href="#"
                                    v-if="!showNotes"
                                    @click.prevent="showNotes = true"
                                >Click to show notes</a>
                            </div>

                            <div>
                                <attachments
                                    v-if="job.id"
                                    type="App\Job"
                                    :id="job.id"
                                />
                            </div>

                            <div class="form-group">
                                <button
                                    type="submit"
                                    class="btn btn-success"
                                >
                                    Save Job
                                </button>
                                <button
                                    type="button"
                                    @click="deleteJob()"
                                    class="btn btn-danger"
                                >
                                    Delete Job
                                </button>
                                <button
                                    type="button"
                                    @click="newJob()"
                                    class="btn btn-info"
                                >
                                    New Job
                                </button>
                                <button
                                    type="button"
                                    @click="showNotes = !showNotes"
                                    class="btn btn-info"
                                    v-if="job.customer_id"
                                >
                                    Toggle Notes
                                </button>
                                <activity-log
                                    v-if="job.id"
                                    :id="job.id"
                                    model="Job"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JobService from "../../../services/JobService";
import CalendarComponent from "../../ResourceCalendarComponent.vue";
import CustomerService from "../../../services/CustomerService";
import UsersService from "../../../services/UsersService";
import datePicker from "../../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../../CustomerSearch.vue";
import * as moment from "moment";
import FormService from "../../../services/FormService";
import * as Job from "../../../include/Job";
import * as Form from "../../../include/Form";
import UsesComments from '../../../mixins/UsesComments';
import TimeSlotsService from '../../../services/TimeSlotsService';
import Attachments from '../../AttachmentsComponent';

export default {
    components: {
        "customer-search": CustomerSearchComponent,
        calendar: CalendarComponent,
        "date-picker": datePicker,
        Attachments,
    },
    mixins: [UsesComments],
    data: function () {
        return {
            jobs: [],
            customers: [],
            engineers: [],
            officeStaff: [],
            job: {
                customer: {
                    company_name: "",
                    forms: [],
                },
                time_slots: [],
                status: 'unstarted',
                color: '#000000',
                first_name: '',
                last_name: '',
            },
            jobService: JobService,
            customerService: CustomerService,
            usersService: UsersService,
            errors: {},
            config: {
                format: "DD/MM/YYYY HH:mm",
                useCurrent: false
            },
            formTypes: Form.types,
            newFormType: null,
            statuses: Job.statuses,
            showNotes: false,
        };
    },

    computed: {
        isJobNew: function () {
            return !this.job.id;
        }
    },

    mounted: function () {
        this.getEngineers().then(() => {
            this.addATime();
        });

        this.getOfficeStaff();

        if (this.$route.query.customer_id) {
            const customerId = this.$route.query.customer_id;
            this.customerService.get(customerId).then(response => {
                this.customerChanged(response.data);
            });
        }

        this.newFormType = this.formTypes[0].value;
    },

    methods: {
        customerChanged: function (customer) {
            if (customer.overdue) {
                const confirm = window.confirm(`This customer's account is overdue, continue with new job?`);
                if (!confirm) {
                    this.job.customer = null;
                    this.$refs.customerSearch.clear();
                    return;
                }
            }
            if (customer.proforma) {
                const confirm = window.confirm(`This customer's account is proforma/cash, continue with new job?`);
                if (!confirm) {
                    this.job.customer = null;
                    this.$refs.customerSearch.clear();
                    return;
                }
            }
            this.showNotes = false;
            this.job.site_id = null;
            if (customer === null) {
                this.job.customer = {};
                this.job.customer_id = null;
            } else {
                this.job.customer = customer;
                this.job.customer_id = customer.id;

            }
            this.setCommentsCustomerId(this.job.customer_id);
            this.setCommentsSiteId('*');
        },
        getEngineers: function () {
            return new Promise((fulfill, reject) => {
                this.usersService.engineers().then(
                    xhr => {
                        this.engineers = xhr.data;
                        fulfill();
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        getOfficeStaff: function() {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    xhr => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        setJob: function (job) {
            this.job = job;
            this.setCommentsCustomerId(this.job.customer_id);
            this.setCommentsSiteId('*');
            for (let i = 0; i < this.job.time_slots.length; i++) {
                this.timeSlotUserChanged(i);
            }

        },

        timeSlotUserChanged(index) {
            const timeSlot = this.job.time_slots[index];
            this.validateTimeslot(index, timeSlot);
            // Set new user based on id
            if (!timeSlot.user ||timeSlot.user_id !== timeSlot.user.id) {
                timeSlot.user = this.engineers.find(e => {
                    return e.id === timeSlot.user_id;
                });
                return;
            }
            // Set user based on user object
            if (timeSlot.user) {
                let inEngineers = this.engineers.findIndex(e => {
                    return e.id === timeSlot.user.id;
                });
                if (inEngineers === -1) {
                    this.engineers.push(timeSlot.user);
                }
                this.job.time_slots[index].user_id = timeSlot.user.id;
            } else {
                // Cannot set the object
                this.job.time_slots[index].user_id = null;
            }
        },

        saveJob: function () {
            this.errors = {};
            if (this.job.id) {
                this.jobService.update(this.job).then(
                    xhr => {
                        this.jobSaved(xhr);
                    },
                    err => {
                        this.saveJobError(err);
                    }
                );
            } else {
                this.jobService.create(this.job).then(
                    xhr => {
                        this.jobSaved(xhr);
                    },
                    err => {
                        this.saveJobError(err);
                    }
                );
            }
        },

        jobSaved: function () {
            this.clearJob();
            this.$store.dispatch('resourceCalendar/loadAll');
            alert("Job saved successfully");
        },

        saveJobError: function (xhr) {
            if (xhr.response.data.errors) {
                this.errors = xhr.response.data.errors;
                alert("Please check the job form for errors");
            } else {
                alert("There was a problem saving the job");
            }
        },

        clearJob: function () {
            this.job = {
                time_slots: [],
                customer: {},
                forms: [],
                status: this.statuses[0].value,
                first_name: '',
                last_name: '',
            };
            this.sites = [];
            this.errors = {};
            this.addATime();
        },

        dayClicked: function ({date, resource}) {
            this.newJob();
            const last = this.job.time_slots.length - 1;
            this.job.time_slots[last].start = moment(date).hour(9);
            this.job.time_slots[last].end = moment(date).hour(10);
            this.job.time_slots[last].user_id = parseInt(resource.id);
            this.timeSlotUserChanged(last);
            this.$forceUpdate();
        },

        daysSelected: function (date, user) {
            if (this.isJobNew) {
                const last = this.job.time_slots.length - 1;
                this.job.time_slots[last].start = moment(date).hour(9);
                this.job.time_slots[last].end = moment(date).hour(10);
                this.job.time_slots[last].user_id = parseInt(user.id);
                this.timeSlotUserChanged(last);
            }
            this.$forceUpdate();
        },

        eventClicked: function ({event}) {
            if (!event.job) {
                return;
            }
            document.getElementById("job-details").scrollIntoView({
                behavior: "smooth",
                block: 'center'
            });
            window.$("input#name").focus();
            if (event.job) {
                this.job = event.job;
                this.jobService.get(this.job.id).then(res => {
                    this.setJob(res.data);
                });
            }
        },

        addATime: function (date = null) {
            if (this.job.time_slots.length) {
                const lastSlot = this.job.time_slots[this.job.time_slots.length - 1];
                this.job.time_slots.push({
                    user: lastSlot.user ? lastSlot.user : this.engineers[0],
                    start: moment(lastSlot.start),
                    end: moment(lastSlot.end)
                });
            } else {
                const newDate = date
                    ? date
                    : moment()
                        .add(1, "hour")
                        .startOf("hour");
                this.job.time_slots.push({
                    start: newDate,
                    end: moment(newDate).add(30, "minutes"),
                    user: this.engineers[0],
                    user_id: this.engineers[0].id
                });
            }
            this.timeSlotUserChanged(this.job.time_slots.length - 1);
            this.$forceUpdate();
        },

        removeATime: function (index) {
            this.job.time_slots.splice(index, 1);
            this.$forceUpdate();
        },

        addAForm: function () {
            if(!this.job.customer_id) {
                alert('Please select a customer first');
                return;
            }
            if(!this.job.site_id) {
                alert('Please select a site first');
                return;
            }
            if(!this.job.id) {
                alert('Please save the job before adding a form');
                return;
            }
            const form = {
                job_id: this.job.id,
                customer_id: this.job.customer_id,
                site_id: this.job.site_id,
                type: this.newFormType,
                add_form_fields: true,
                is_complete: false,
            };
            FormService.nextNo().then(res => {
                form.doc_no = res.data;
                FormService.create(form).then(res => {
                    this.job.forms.push(res.data);
                }, () => {
                    alert('Error: Could not create new form');
                });
            });

        },

        deleteForm: function (i) {
            const form = this.job.forms[i];
            if (form.id) {
                if (confirm('Are you sure you want to delete this form?')) {
                    FormService.delete(form).then(() => {
                        this.job.forms.splice(i);
                    }, () => {
                        alert('Error: could not delete form');
                    });
                }
            } else {
                this.job.forms.splice(i);
            }
        },

        deleteJob: function () {
            const confirm = window.confirm(
                "Are you sure you want to delete this job?"
            );
            if (!confirm) {
                return;
            }
            if (this.isJobNew) {
                this.newJob();
            } else {
                this.jobService.delete(this.job).then(
                    () => {
                        this.$store.dispatch('resourceCalendar/loadAll');
                        this.newJob();
                    },
                    () => {
                        alert("Error: Job could not be deleted");
                    }
                );
            }
        },

        newJob: function () {
            this.clearJob();
        },

        eventDrop: function (event) {
            if (event.job) {
                this.job = event.job;
                for (let ts of this.job.time_slots) {
                    if (ts.id === event.id) {
                        ts.start = event.start;
                        ts.end = event.end;
                        ts.user_id = event.resourceId;
                        this.timeSlotUserChanged(this.job.time_slots.indexOf(ts));
                    }
                }
                this.saveJob();
            }
        },

        validateTimeslot (index, timeSlot) {
            // Disabled as part of #8699zk9wc
            return;

            delete(this.errors['time_slots.'+index+'.start']);
            if (!timeSlot.start || !timeSlot.end || !timeSlot.user_id) {
                return;
            }
            const data = {
                start: window.moment(timeSlot.start).format('YYYY-MM-DD HH:mm:ss'),
                end: window.moment( timeSlot.end).format('YYYY-MM-DD HH:mm:ss'),
                user_id: timeSlot.user_id
            };
            if (this.job.id) {
                data.job_id = this.job.id;
            }
            TimeSlotsService.validateTimeSlot(data).then().catch(err => {
                this.errors['time_slots.'+index+'.start'] = err.response.data.errors;
                this.$forceUpdate();
            })
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/jobs/ScheduleComponent.vue